/**
 * 主路由 具体内容 有接口配置
 * 这里只进行页面注册
 */
import filmLayout from '@/views/filmclient/layout';
export default [
  {
    path: '/film',
    component: filmLayout,
    redirect: '/filmclient',
    hidden: true,
    children : [
      {
        path: '/filmclient',
        name: 'filmclient',
        component: () => import('@/views/filmclient/filmSelect.vue'),
        meta: {
          title: '选片首页'
        }
      },{
        path: '/filmclient/filmbuy',
        name: 'filmbuy',
        component: () => import('@/views/filmclient/filmBuy.vue'),
        meta: {
          title: '选片购买'
        }
      },{
        path: '/filmpreview',
        name: 'filmpreview',
        component: () => import('@/views/filmclient/filmpreview.vue'),
        meta: {
          title: '预告片列表'
        }
      },{
        path: '/cinemalist',
        name: 'cinemalist',
        component: () => import('@/views/filmclient/cinemaList.vue'),
        meta: {
          title: '影院列表'
        }
      },{
        path: '/cinemalist/cinemafilm',
        name: 'cinemafilm',
        component: () => import('@/views/filmclient/cinemaFilm.vue'),
        meta: {
          title: '影院选片'
        }
      },{
        path: '/seatSelect',
        name: 'seatselect',
        component: () => import('@/views/filmclient/seatSelect.vue'),
        meta: {
          title: '选座'
        }
      },{
        path: '/filmPay',
        name: 'filmpay',
        component: () => import('@/views/filmclient/filmPay.vue'),
        meta: {
          title: '支付订单'
        }
      },{
        path: '/suo',
        name: 'suo',
        component: () => import('@/views/filmclient/suo.vue'),
        meta: {
          title: '支付订单'
        }
      }
    ]
  },
  {
    path: '/register_login',
    name: 'register_login',
    component: () => import('@/views/filings/login.vue'),
    meta: {
      title: '登录'
    }
  }
]
